import Base from './components/cells/Base';
import Text from './components/cells/Text';

export default function TextCell() {}

TextCell.prototype.init = function (params) {
    this.eGui = Base(Text(params), params);
    return;
};

TextCell.prototype.getGui = function () {
    return this.eGui;
};
